import React from 'react';
import { H2, Caption } from '~/shared/Typography';
import { HStack } from 'native-base';
import { useSpringBigStore } from '@springbig/shared';
import { useAppNavigate } from '..';
import { Button, Panel, Modal, Section } from '~/shared/Theme';
import { ProfileForm } from '~/pages/profile/components/ProfileForm';

const AccountInformationScreen = () => {

    const { member } = useSpringBigStore();
    const [showDeleteModal, setShowDeleteModal] = React.useState(false);

    const { navigate, params } = useAppNavigate();

    const handleDeleteAccount = () => {

        navigate(`w/${params.wallet_id}/profile/menu/account/remove`);
    };

    return (
        <Section>
            { member &&
                <ProfileForm />
            }
            <Panel>
                <Button
                    alignSelf={'flex-end'}
                    variant={'danger'}
                    onPress={(() => {

                        setShowDeleteModal(true);
                    })}
                    text={'accountInformation.delete_account'}
                />
            </Panel>
            <Modal isOpen={showDeleteModal}>
                <Modal.Header>
                    <H2 text={'accountInformation.delete_account_title'} />
                </Modal.Header>
                <Modal.Body>
                    <Caption text={'accountInformation.delete_account_message'} />
                </Modal.Body>
                <Modal.Footer>
                    <HStack space={4}>
                        <Button
                            text={'general.cancel'}
                            variant={'neutral'}
                            onPress={() => setShowDeleteModal(false)}
                        />
                        <Button
                            text={'accountInformation.delete_account'}
                            variant={'danger'}
                            onPress={() => {

                                setShowDeleteModal(false);
                                handleDeleteAccount();
                            }}
                        />
                    </HStack>
                </Modal.Footer>
            </Modal>
        </Section>
    );
};

export default AccountInformationScreen;
